import React, { ComponentProps } from "react"
import { CardElement as StripeCardElement } from "@stripe/react-stripe-js"

type CardElementProps = ComponentProps<typeof StripeCardElement> & {
  onChange: (success: boolean) => void
  disabled?: boolean
  showZip?: boolean
}

export default React.memo<CardElementProps>(function CardElement({
  onChange,
  disabled,
  showZip = false,
  ...props
}) {
  return (
    <StripeCardElement
      onChange={({ complete }) => {
        onChange(complete)
      }}
      options={{
        hidePostalCode: !showZip,
        style: {
          base: {
            color: "black",
            fontSize: "16px",
            "::placeholder": {
              color: "rgba(0,0,0,0.54)",
            },
          },
        },
        disabled,
      }}
      {...props}
    />
  )
})
